import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './useAuth';
import { Spinner } from '@/components/Spinner';
import type { ReactNode } from 'react';

/*
  ProtectedRoute — gate для защищённых маршрутов.

  - status=loading → показываем спиннер (страница ещё не определилась)
  - status=anonymous → редирект на /login c return_to=<текущий путь>
  - status=error → редирект на /login с error-параметром (на login-экране
    покажем сообщение)
  - status=authenticated → рендерим children
*/

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { state } = useAuth();
  const location = useLocation();

  if (state.status === 'loading') {
    return (
      <div className="flex h-screen items-center justify-center">
        <Spinner />
      </div>
    );
  }

  if (state.status === 'anonymous') {
    const returnTo = location.pathname + location.search;
    return <Navigate to={`/login?return_to=${encodeURIComponent(returnTo)}`} replace />;
  }

  if (state.status === 'error') {
    return <Navigate to="/login?error=bootstrap" replace />;
  }

  return <>{children}</>;
}
